"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fee = void 0;
var Serialization_1 = require("../../../Handlers/Serialization");
var Lock_1 = require("./Lock");
var Fee = /** @class */ (function (_super) {
    __extends(Fee, _super);
    function Fee() {
        return _super.call(this, Lock_1.LockIdentifiers.Fee) || this;
    }
    Fee.read = function (buffer, offset) {
        var _a = Serialization_1.readVarInt(buffer, offset), size = _a.value, size_offset = _a.offset;
        if (size !== Lock_1.Lock.sizeOfZero)
            throw new Error("invalid feelock size");
        return { lock: new Fee(), offset: size_offset };
    };
    Fee.prototype.getDataAsString = function () {
        return '';
    };
    Fee.prototype.getSize = function () {
        var payload = Lock_1.Lock.sizeOfZero;
        return _super.prototype.getSize.call(this) + Serialization_1.getSizeOfVarInt(payload) + payload;
    };
    Fee.prototype.write = function (buffer, offset) {
        offset = Serialization_1.writeVarInt(this.identifier, buffer, offset);
        offset = Serialization_1.writeVarInt(0, buffer, offset);
        return offset;
    };
    Fee.prototype.toApiJson = function () {
        return "Fee";
    };
    return Fee;
}(Lock_1.Lock));
exports.Fee = Fee;
//# sourceMappingURL=Fee.js.map